import { type Address, AddressDefault } from "./address";

export interface ContactData {
  contactId: string; //ULID、並び替えしたりしても見つかるように

  // 宛先 // 650-0025 神戸市中央区相生町5-10-21 相生ビル201
  address: Address;

  // 部門名 // インフラ部門
  name: string;
  title: string; // 敬称 // 御中

  // 担当者
  person: {
    position: string; // 役職 // 相互接続部長
    name: string; // 担当者氏名 // 國本 倫平
    title: string; // 敬称 // 様
  };

  // 自社担当者
  phone: string;
  fax: string;
  emailAddress: string;
  ccEmailAddresses: string[];
}

export const ContactDataDefault: ContactData = {
  contactId: "",
  address: AddressDefault,
  name: "",
  title: "",
  person: {
    position: "",
    name: "",
    title: "",
  },
  phone: "",
  fax: "",
  emailAddress: "",
  ccEmailAddresses: [],
} as const;
